/**
 * @desc 根据sku编码获取sku详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuDetailInfoResponseDto>;
export function request(skuNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/getSkuDetailBySkuNo/${skuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
